import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import TaskEdit from "./TaskEdit";

import { useReactToPrint } from "react-to-print";
import { useRef } from "react";


const TaskView = () => {
  const [displayTask, setDisplayTask] = useState([]);
  const printRef=useRef(null)
  const [changes , setChanges] = useState(false)
  const [taskId, setTaskId] = useState(null)
  const [viewMore, setViewMore] = useState(true)


  useEffect(() => {
    api
      .get("/tasks/")
      .then((response) => {
        setDisplayTask(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [changes]);

  const handleDelete = (id) => {
    api
      .delete(`/tasks/${id}/`)
      .then((response) => {

        let newData = displayTask.filter((item, i) => item.id !== id)
        setDisplayTask(newData)
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });

  }

const print=useReactToPrint({
  content:()=>printRef.current
})

 


  const handleApprove = (id)=> {

    let data = {
      status : "completed"
    }

    api.patch(`tasks/${id}/`, data)
    .then(response=> {
      setChanges(true)
      toast.success("Approve Successfully")
    }).catch(err=> {
      toast.error("Something went wrong")
    })
 
  }

  const handleSearch = (e) => {

      api.get(`tasks/?search=${e.target.value}`)
      .then(response=> {
        // console.log(response.data)
        setDisplayTask(response.data)
      }).catch(error=> {
        console.log(error)
      })
  
  }


  return (
    <div>
      <div className="">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          Task Assigned List
        </h1>
        <div className="">
          <img
            src="../../images/title-border.png"
            alt=""
            className="mx-auto mt-4"
          />
        </div>
        {/*  table */}
        <div  className="mt-3  w-full md:px-10">
          <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  {/* search */}
                  <div className="flex justify-between">
                    <input
                      type="search"
                      onChange={(e)=> handleSearch(e)}
                      name="staff"
                      placeholder="Search by Staff Name "
                      id="table-search"
                      className="mb-2 block w-80 outline-none  rounded-lg border border-primary-blue bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                    />
                    <input
                      type="search"
                      placeholder="Search by Date " 
                      name="date"
                      onChange={(e)=> handleSearch(e)}
                      id="table-search"
                      className="mb-2 block w-80 rounded-lg border outline-none  border-primary-blue bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                  <table ref={printRef} className="border-primary-blue min-w-full border text-center">
                    <thead className="font-Bree bg-primary-red text-lg font-bold">
                      <tr className="">
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          SN.
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          T.No
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          T.A Date
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          Details
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          Company Name
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          Staff Name
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          Edit/View
                        </th>
                        <th
                          scope="col"
                          className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                        >
                          Task Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="font-Acme">

<tr>

                      {displayTask.length < 1 && "No Data Found ....."}

                              
</tr>

                      {
                        displayTask?.slice(0, `${viewMore ? 10 : displayTask.length}`).map((item, index) => {
                          return (
                            <tr key={item.id} className="border-primary-blue border-2  bg-white">
                              
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light">
                                {index + 1}
                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light">
                                {item.id}
                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light">
                                {/* {item.assigned_at} */}
                                { item.assigned_at.split('T')[0] }
                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light">
                                {item.job_details}
                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light">
                                {item.company_name}
                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                                {item.assigned_to_name}
                              </td>
                              <td className=" flex gap-2 text-primary-blue whitespace-nowrap rounded-full  py-2 px-4 text-sm">

                                {/* <div  onClick={()=> setTaskId(item.id)} > */}
                                <button data-bs-toggle="modal" 
                                onClick={()=> setTaskId(item.id)}  
                                  data-bs-target="#EditTaskModal" 
                                  className="bg-red-600 text-white rounded-xl p-1 cursor-pointer hover:bg-primary-blue">
                                    Edit
                              </button>
                              {/* </div> */}

                                <button onClick={()=> handleApprove(item.id)}
                                className="bg-red-600  text-white rounded-xl p-1 cursor-pointer hover:bg-primary-blue"
                                >
                                  Approve
                                </button>


                                <button 
                                  data-bs-toggle="modal"
                                  data-bs-target="#DeleteLinkModalDemo" className="bg-red-600 text-white rounded-xl p-1   hover:bg-primary-blue cursor-pointer">Delete</button>
                                {/* Delete Modal */}
                                <div
                                  className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                                  id="DeleteLinkModalDemo"
                                  tabIndex={-1}
                                  aria-labelledby="exampleModalLabel"
                                  aria-modal="true"
                                  role="dialog"
                                >
                                  <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                                    <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                                      <div className="flex justify-end">
                                        <svg
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          className="text-primary-blue h-8 w-8"
                                          xmlns="http://www.w3.org/2000/svg"
                                          aria-hidden="true"
                                          role="img"
                                          preserveAspectRatio="xMidYMid meet"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                                          />
                                        </svg>
                                      </div>
                                      <div className="modal-header rounded-t-md  border-gray-200 text-2xl text-">
                                        Are you sure want to Delete Task ?
                                      </div>
                                      <div className="flex justify-center gap-2 my-3">
                                        <div data-bs-dismiss="modal"
                                          aria-label="Close"
                                          className="bg-red-600 hover:bg-primary-blue text-white rounded-2xl p-2 cursor-pointer " onClick={() => { handleDelete(item.id); }}>Delete</div>

                                        <div
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        >

                                          <div className="bg-red-600 text-white rounded-2xl p-2 cursor-pointer ">Cancel</div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* Edit Modal */}

                                <div
                                  className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                                  id="EditTaskModal"
                                  tabIndex={-1}
                                  aria-labelledby="exampleModalLabel"
                                  aria-modal="true"
                                  role="dialog"
                                >
                                  <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                                    <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                                      <div className="flex justify-end">
                                        <svg
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          className="text-primary-blue h-8 w-8"
                                          xmlns="http://www.w3.org/2000/svg"
                                          aria-hidden="true"
                                          role="img"
                                          preserveAspectRatio="xMidYMid meet"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                                          />
                                        </svg>
                                      </div>
                                      <div>
                                        <TaskEdit  taskId={taskId}/>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </td>
                              <td className="border-primary-blue text-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                                {item.status}
                              </td>
                            </tr>
                          )
                        })
                      }

                    </tbody>
                  </table>

                  <div className="mt-5 flex items-center justify-end gap-10">
                    <div onClick={print} className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                      <button >Print List</button>
                    </div>

                    <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                      {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TaskView;
